import moment from 'moment';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TRADER_PAYOUT_ORDER_STATUSES } from 'constants/order.constants';
import {
  AdditionalOrderColumn,
  FilterDefinitionType,
  OrdersTab,
  PayoutOrderStatus,
  PayoutOrderStatusDetails,
} from 'enums';
import { useOrderQueryFilters, useQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { TraderOrderList } from '../OrderList';

export const TraderAllOrders: React.FC = () => {
  useQueryFilters<OrderFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
    statuses: [PayoutOrderStatus.Completed, PayoutOrderStatus.Cancelled],
  });

  const { t: tFilters } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.filters',
  });

  useOrderQueryFilters();

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [
      orderUtils.getStatusFilterDefinition(TRADER_PAYOUT_ORDER_STATUSES),
      {
        label: tFilters('status_details'),
        name: 'statusDetails',
        type: FilterDefinitionType.Enum,
        enum: PayoutOrderStatusDetails,
        getDisplayName: orderUtils.getPayoutStatusDetailsLabel,
      },
    ],
    [tFilters],
  );

  return (
    <TraderOrderList
      tab={OrdersTab.All}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.AutomationStatus,
      ]}
    />
  );
};
